import { forwardRef } from 'react';
import type { ColorSwatchProps } from './ColorSwatch.types';

const squareButtonBaseClasses =
  'tw:cursor-pointer tw:border tw:border-gray-700 tw:dark:border-gray-500 tw:shadow-sm tw:focus-visible:outline-none';

const sizeClasses = {
  sm: 'tw:h-5 tw:w-5 tw:rounded',
  md: 'tw:h-6 tw:w-6 tw:rounded-md',
  lg: 'tw:h-8 tw:w-8 tw:rounded-lg',
} as const;

const ColorSwatch = forwardRef<HTMLButtonElement, ColorSwatchProps>(function ColorSwatch(
  { color, onClick, 'aria-label': ariaLabel, size = 'lg', extraClassNames = '', id, testId },
  ref,
) {
  return (
    <button
      ref={ref}
      aria-label={ariaLabel}
      className={`${squareButtonBaseClasses} ${sizeClasses[size]} ${extraClassNames}`}
      data-testid={testId}
      id={id}
      onClick={onClick}
      style={{ backgroundColor: color }}
      type="button"
    />
  );
});

export default ColorSwatch;
